import { useState, useEffect } from "react";
import { getAxios } from "../../utils/endpoints";

type LPSource = {
  sourceSiteName: string;
  lpSiteAddress: string;
  lpClientID: string;
};

type LpAccount = {
  dealerName: string;
  lpSiteAddress: string;
  lpClientId: string;
};

export const useDealerLinks = () => {
  const [lpAccounts, setLpAccounts] = useState<LpAccount[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const mapToLpAccount = (source: LPSource): LpAccount => ({
    dealerName: source.sourceSiteName,
    lpClientId: source.lpClientID,
    lpSiteAddress: source.lpSiteAddress,
  });

  const onFetchLpAccounts = async () => {
    try {
      const response = await getAxios("/data-sync/sources", "GET");
      const data: LPSource[] = response.data ?? [];

      const mappedAccounts = data.map(mapToLpAccount);

      setLpAccounts(mappedAccounts);
    } catch (error) {
      console.error("Failed to fetch LP accounts:", error);
      setLpAccounts([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    onFetchLpAccounts();
  }, []);

  return {
    lpAccounts,
    isLoading,
  };
};